// extracted by mini-css-extract-plugin
export var section = "bsa-description-module--section--+gVpS";
export var title = "bsa-description-module--title--98obY";
export var description = "bsa-description-module--description--eu4SC";
export var subsection = "bsa-description-module--subsection--yw7Lg";
export var subtitle = "bsa-description-module--subtitle--mbWnC";